<div>
  <ul *ngFor="let err of validationSummary?.errors">
      <li>{{err.message}}</li>
  </ul>
</div>
